import { render, staticRenderFns } from "./AccountSuccess.vue?vue&type=template&id=2919a016&scoped=true&"
var script = {}
import style0 from "./AccountSuccess.vue?vue&type=style&index=0&id=2919a016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2919a016",
  null
  
)

export default component.exports